import {AlertService} from '../../shared/services/alert.service';
import {AuthService} from '../../login/services/auth.service';
import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Company } from "../../shared/models/company";
import { CompanyService } from "../../shared/services/company.service";
import { DacConfig } from 'app/shared/services/dac-config.service';
import { AmplifyService } from 'aws-amplify-angular';
import { Subscription } from 'rxjs/Subscription';
import { MetricsService } from 'app/shared/services/metrics.service';

@Component({
  selector: 'dac-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  public signupLogo: string;
  private _company:Company;
  private _authState:string;

  public isPerformingAction:boolean;
  public password:string;
  public confirmPassword:string;
  public processingSignup:boolean = false;
  public confirmationCode:string;
  private _authStateSubscription:Subscription;
  private readonly METRIC_CATEGORY = 'signup';

  constructor(private companyService:CompanyService, private router:Router
    , private route:ActivatedRoute
  ,private authService:AuthService,
  private amplifyService:AmplifyService,
   private alertService:AlertService
  ,private dacConfig:DacConfig
  ,private elementRef:ElementRef
  ,private metrics:MetricsService) { 
    this._company = new Company();
    this.isPerformingAction = false;
    this._authState = 'signUp';
    this._authStateSubscription = this.amplifyService.authStateChange$.subscribe(authState => {
      this._authState = authState.state;
    });
    // this.amplifyService.setAuthState({state: 'signUp', user:null});
  }

  ngOnDestroy() {
    if (this._authStateSubscription) {
      this._authStateSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.signupLogo = this.dacConfig.applicationLogoUrl
    this.amplifyService.setAuthState({state: 'signUp', user:null});
  }

  private trackSignup(action:string, name?:string) {
    this.metrics.trackEvent(this.METRIC_CATEGORY, action, name);
  }

  get authState() {
    return this._authState;
  }

  get Company() {
    return this._company;
  }

  public handlePlan(plan:"Custom"|"Therapist") {
    // custom will go to the contact page.
    if (plan == "Therapist") {
      this.handleCTA();
    }
    return;
  }

  public handleCTA() {
    let el = this.elementRef.nativeElement as HTMLElement;
    let home = el.querySelector("#home");
    home.scrollIntoView(true);
  }

  public showPartner(partner:string) {
    if (this.dacConfig.hasPartner(partner)) {
      return true;
    }
    return false;
  }
  public confirmSignup() {
    this.trackSignup('confirmSignup');
    let code = this.confirmationCode.trim();
    this.processingSignup = true;
    this.amplifyService
    .auth()
    .confirmSignUp(this.Company.email, code)
    .then(() => {
      this.trackSignup('confirmSignup', 'cognito confirmed');
      this.registerNewCompany();
    })
    .catch((error) => { 
      this.trackSignup('confirmSignup', 'code invalid or error');
      this.processingSignup = false;
      console.error(error);
      let msg = error.message || error || "There was an error in confirming your code.  Please try again or contact support";
      this.alertService.error(msg); 
    });
  }

  public resendConfirmationCode(evt:Event) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    this.trackSignup('resentConfirmationCode');

    this.amplifyService
        .auth()
        .resendSignUp(this.Company.email)
        .then(() => {
          this.trackSignup('resentConfirmationCode', 'code resent');
          this.alertService.info("Confirmation code resent. Check your email for confirmation");
        })
        .catch((error) => {
          this.trackSignup('resentConfirmationCode', 'code failed to resend');
          console.error(error);
          this.alertService.error("There was an error resending the confirmation code.  Please try again");
        });
    return false;
  }

  public signup() {
    this.trackSignup('signupClicked');
    // we are going to clear our local storage to make sure everything is reset
    try {
      sessionStorage.clear();
      localStorage.clear();
    }
    catch (error) {
      this.trackSignup('signupClicked', 'clear storage failed');
      console.error("Failed to clear local and session storage", error);
    }
    if (!this.Company.name || this.Company.name.trim() == "") {
      this.alertService.error("Please provide a name for your company");
      this.trackSignup('signupClicked', 'invalid company name');
      return;
    }
    if (!this.Company.email || this.Company.email.trim() == "" || this.Company.email.indexOf("@") < 0) {
      this.trackSignup('signupClicked', 'invalid email');
      this.alertService.error("Please provide a valid email for your company");
      return;
    }
    let passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
    if (!this.password || this.password.length < 8) {
      this.trackSignup('signupClicked', 'invalid password length');
      this.alertService.error(passwordPolicyMsg);
      return;
    }
    if (!this.password.match(/[0-9]+/)) {
      this.trackSignup('signupClicked', 'invalid password number');
      this.alertService.error(passwordPolicyMsg);
      return;
    }
    if (!this.password.match(/[A-Z]+/)) {
      this.trackSignup('signupClicked', 'invalid password uppercase');
      this.alertService.error(passwordPolicyMsg);
      return;
    }
    if (!this.password.match(/[a-z]+/)) {
      this.trackSignup('signupClicked', 'invalid password lowercase');
      this.alertService.error(passwordPolicyMsg);
      return;
    }
    // if (this.password != this.confirmPassword) {
    //   this.alertService.error("Passwords do not match");
    //   return;
    // }
    this.processingSignup = true;

    this._company.user.username = this.Company.email;

    this.amplifyService.auth().signUp({
      // email: this.Company.email,
      username: this.Company.email,
      password: this.password,
      attributes: {
        //   email: this.Company.email,          // optional
         'custom:companyName': this.Company.name
      },
      validationData: []  //optional
      })
      .then(data => {
        this.trackSignup('signupClicked', 'cognito signup');
        // TODO: stephen do we save off the lead here...
        this.processingSignup = false;
        this.amplifyService.setAuthState({state: 'confirmSignUp', user: data.user});
      })
      .catch(err => 
        {
          if (err.code === "UsernameExistsException") {
            this.trackSignup('signupClicked', 'duplicate email');
            this.alertService.error("That email address already exists.  Please choose a different one or login");
          }
          else if (err.code == 'InvalidParameterException') {
            this.trackSignup('signupClicked', 'invalid cognito parameter');
            this.alertService.error(err.message);
          }
          else {
            this.trackSignup('signupClicked', 'system error occurred');
            this.alertService.error("There was an error creating your account.  Check your information and try again or contact our support");
          }
          this.processingSignup = false;
          console.log(err)
      });

    }
    public registerNewCompany() {
      this.trackSignup('registerNewCompany');
      // this._company.user.password = this.password;
      // TODO: need to handle any referral and other pieces of information as part of this registration
      const user = this.amplifyService.auth().signIn(this._company.email, this.password)
        .then((user) => {
          this.trackSignup('registerNewCompany', 'cognito signIn success');
          let authToken = user.signInUserSession.accessToken.jwtToken;
          // registration will only work if there is a valid auth token here...
          this.companyService.registerNewCompany(this._company, authToken)
            .then((company) => {
              this.trackSignup('registerNewCompany', 'company registered');
                // now let's login in and authenticate here...              
                this.authService.authenticateCognito(user).then(() => {
                  this.trackSignup('registerNewCompany', 'authentication complete');
                  this.password = "";
                  this.alertService.success("Registration complete. Sending you on to your dashboard.");
                  setTimeout(() => {
                    this.router.navigate(["/admin/"]);
                    this.processingSignup = false;
                  }, 3000);
                })
                .catch(error => {
                  this.trackSignup('registerNewCompany', 'authentication failed');
                  this.processingSignup = false;
                  console.error(error);
                  this.alertService.error("Failed to log you in.  Redirecting to login page");
                  this.router.navigate(["/loginAdmin"]);
                })
            })
            .catch(error => {
              this.trackSignup('registerNewCompany', 'company registration failed');
              this.processingSignup = false;
              console.error(error); // TODO: stephen this error needs to be transmitted to the server.
              this.alertService.error("Failed to sign you in and complete creation of your account.  Please contact customer support for assistance.");
              this.amplifyService.auth().signOut({ global: true }); // sign out if we failed to login.
              this.amplifyService.setAuthState({state: 'signUp', user: null});
            })
        })
        .catch(error => {
          this.trackSignup('registerNewCompany', 'cognito signIn failed');
          console.error(error); // TODO: stephen this error needs to be transmitted to the server.
          this.alertService.error("Failed to sign you in and complete creation of your account.  Please contact customer support for assistance.")
        })

        
  }

  public getFreeTrialPeriod() {
    return 14;
  }

}



// WEBPACK FOOTER //
// ./src/app/companies/signup/signup.component.ts